import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-show-controls-upgrade-popup',
  standalone: false,
  templateUrl: './show-controls-upgrade-popup.component.html',
  styleUrl: './show-controls-upgrade-popup.component.scss'
})
export class ShowControlsUpgradePopupComponent {
  public title = '';
  isAdmin = false;
  subscription_Plan: any;
  constructor(private dialogRef: MatDialogRef<ShowControlsUpgradePopupComponent>,
    @Inject(MAT_DIALOG_DATA) data: any ,private router: Router) {
    this.title = data.title;
    this.subscription_Plan = data.subscription_Plan;
    this.isAdmin = data.isAdmin;

  }
  cancel(){
    this.dialogRef.close(false);
  }
  goToSubscription() {
    this.router.navigate(['/subscription']);
     this.dialogRef.close(false);
  }
}
